import script from "./selectUser.vue?vue&type=script&lang=ts&setup=true"
export * from "./selectUser.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__